module.exports = __webpack_public_path__ + "img/IS.82932098.jpg";